import React, { useEffect, useState } from "react";
import EWallet from "../Components/Admin/MainDashboard/Reuse/EWallet";
import axios from "axios";
import Wallet from "../Components/SuperStar/MainDashboard/Screen/Wallet";

const E_WalletStar = () => {
  const [totalIncomeData, setTotalIncomeData] = useState();

  const [income, setIncome] = useState();
  useEffect(() => {
    axios.get("/api/star/dashboard").then((res) => {
      if (res.data.status === 200) {
        setTotalIncomeData(res.data.totalIncomeStatement);
        setIncome(res.data);
      }
    });
  }, []);

  return (
    <>
      {/* <EWallet
        title={"E-Wallet"}
        amount={adminProfit(totalIncomeData?.totalIncome)}
        id={1}
      /> */}

      <div className="row  mt-2">
        <Wallet props={totalIncomeData} />
      </div>

      <div className="row mt-5">
        <EWallet
          title={"Live Chat"}
          amount={income?.liveChat?.liveChatTotalIncome}
          id={1}
        />
        <EWallet title={"Q&A"} amount={income?.qna?.qnaTotalIncome} id={1} />
        <EWallet
          title={"Learning Session"}
          amount={income?.learning?.learningSessionTotalIncome}
          id={1}
        />
        <EWallet
          title={"Meetup Event"}
          amount={income?.meetup?.meetupTotalIncome}
          id={1}
        />
        <EWallet
          title={"Greetings"}
          amount={income?.greeting?.greetingTotalIncome}
          id={1}
        />
        <EWallet
          title={"Marketplace"}
          amount={income?.marketplace?.marketplaceTotalIncome}
          id={1}
        />
        <EWallet
          title={"Souvenir"}
          amount={income?.souvenir?.souvenirTotalIncome}
          id={1}
        />
        <EWallet
          title={"Auction"}
          amount={income?.auction?.auctionTotalIncome}
          id={1}
        />
        <EWallet
          title={"Simple Post"}
          amount={income?.simplepost?.simplePostTotalIncome}
          id={1}
        />
      </div>
    </>
  );
};

export default E_WalletStar;
